import React, { useMemo } from "react";
import { useUser } from "lib/user";
import { withErrorBoundary } from "react-error-boundary";
import { Logger } from "lib/logger";
import { useRouter } from "lib/router";
import { useScreenViewport } from "lib/checkViewport";
import { useChatPosition } from "hooks";
import { StickyFooterMember } from "./StickyFooterMember";

type DigitalGeniusPositionProps = {
  hasMembership: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isExperimentalPdp: boolean;
};
export const getChatPosition = ({
  hasMembership,
  isMobile,
  isTablet,
  isExperimentalPdp
}: DigitalGeniusPositionProps): number => {
  if (hasMembership) {
    if (isExperimentalPdp) {
      if (isMobile) return 145;
      if (isTablet) return 170;
      return 70;
    }
    // new experience with a membership
    return isMobile ? 50 : 70;
  }
  // new experience without a membership
  if (isExperimentalPdp) {
    if (isMobile) return 110;
    if (isTablet) return 130;
  }
  if (hasMembership) {
    // old experience
    return 70;
  }
  return 16;
};

const StickyFooterWrapperComp: React.FC = () => {
  const router = useRouter();
  const { isMobile, isTablet } = useScreenViewport();
  const { isMember, hasMembership } = useUser();

  const isExperimentalPdp = router.pathname.startsWith("/products/");

  const chatPosition = useMemo(
    () =>
      getChatPosition({
        hasMembership,
        isExperimentalPdp,
        isMobile,
        isTablet
      }),
    [hasMembership, isExperimentalPdp, isMobile, isTablet]
  );

  useChatPosition({ bottom: chatPosition });

  return isMember ? (
    <StickyFooterMember isExperimentalPdp={isExperimentalPdp} />
  ) : null;
};

export const StickyFooterWrapper = withErrorBoundary(StickyFooterWrapperComp, {
  fallback: <div />,
  onError(error) {
    Logger.warn(`Sticky footer failed to load. ${error}`);
  }
});
